var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7617 1.37945L5.14891 9.99229C5.0739 10.0676 4.98476 10.1273 4.88661 10.168C4.78847 10.2088 4.68324 10.2298 4.57697 10.2298C4.4707 10.2298 4.36547 10.2088 4.26732 10.168C4.16917 10.1273 4.08004 10.0676 4.00502 9.99229L0.236908 6.22417C0.161799 6.14906 0.102219 6.0599 0.0615703 5.96176C0.0209216 5.86363 1.11921e-09 5.75845 0 5.65223C-1.11921e-09 5.54601 0.0209216 5.44083 0.0615703 5.34269C0.102219 5.24456 0.161799 5.15539 0.236908 5.08028C0.312017 5.00517 0.401184 4.94559 0.499319 4.90494C0.597453 4.86429 0.702634 4.84337 0.808854 4.84337C0.915074 4.84337 1.02025 4.86429 1.11839 4.90494C1.21652 4.94559 1.30569 5.00517 1.3808 5.08028L4.57764 8.27712L12.6192 0.236908C12.7709 0.0852181 12.9766 0 13.1911 0C13.4057 0 13.6114 0.0852181 13.7631 0.236908C13.9148 0.388597 14 0.594332 14 0.808854C14 1.02338 13.9148 1.22911 13.7631 1.3808L13.7617 1.37945Z",
    fill: "#44CAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e00901dbb5957bf8c89a5c50b9fd7e5f.svg";
export { ForwardRef as ReactComponent };